import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, mergeProps as _mergeProps, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-82b7d48c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pagination" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "seats_pagination_bullet" }, null, -1 /* HOISTED */))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode($setup["Swiper"], _mergeProps({ id: "seat-layout-swiper" }, $setup.swiperOptions), {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.seatsInfosList, (seatsInfo, index) => {
          return (_openBlock(), _createBlock($setup["SwiperSlide"], {
            key: index,
            class: "seat-layout-slide"
          }, {
            default: _withCtx(() => [
              _createVNode($setup["SeatsLayout"], {
                ref_for: true,
                ref: "seatsLayoutRef",
                currentFloor: index + 1,
                totalFloor: $props.seatsInfosList.length,
                seatsInfo: seatsInfo,
                numberOfRows: $props.seatsRowsNumList[index],
                numberOfColumns: $props.seatsColumnsNumList[index],
                mySeatNo: $props.mySeatNo,
                selectable: $props.selectable,
                backgroundColor: $props.backgroundColor,
                seatFontColor: $props.seatFontColor,
                selectedSeatBackgroundColor: $props.selectedSeatBackgroundColor,
                selectedSeatFontColor: $props.selectedSeatFontColor,
                duplicateSeatNo: $props.duplicateSeatNo,
                onOnClickSeat: $setup.onClickSeat
              }, null, 8 /* PROPS */, ["currentFloor", "totalFloor", "seatsInfo", "numberOfRows", "numberOfColumns", "mySeatNo", "selectable", "backgroundColor", "seatFontColor", "selectedSeatBackgroundColor", "selectedSeatFontColor", "duplicateSeatNo"])
            ]),
            _: 2 /* DYNAMIC */
          }, 1024 /* DYNAMIC_SLOTS */))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      _: 1 /* STABLE */
    }, 16 /* FULL_PROPS */),
    _withDirectives(_createElementVNode("div", _hoisted_1, [..._hoisted_3], 512 /* NEED_PATCH */), [
      [_vShow, $props.seatsInfosList.length > 1]
    ])
  ]))
}